
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface SecondaryEmailsListProps {
  secondaryEmails: string[];
  isSubmitting: boolean;
  onRemoveEmail: (email: string) => void;
}

export const SecondaryEmailsList = ({
  secondaryEmails,
  isSubmitting,
  onRemoveEmail,
}: SecondaryEmailsListProps) => {
  if (secondaryEmails.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mb-2">
      {secondaryEmails.map((email, index) => (
        <Badge key={index} variant="secondary" className="flex items-center gap-1">
          {email}
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="h-4 w-4 p-0 hover:bg-transparent"
            onClick={() => onRemoveEmail(email)}
            disabled={isSubmitting}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      ))}
    </div>
  );
};
